/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-unknown-property */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ADD_FLIGHT } from '../redux/flightBooking/actionTypes';

function AddFlight() {
  const dispatch = useDispatch();
  const [destinationFrom, setDestinationFrom] = useState('');
  const [destinationTo, setDestinationTo] = useState('');
  const [journeyDate, setJourneyDate] = useState('');
  const [guests, setGuests] = useState('');
  const [flightClass, setFlightClass] = useState('');

  const addFlight = () => {
    return {
      type: ADD_FLIGHT,
      payload: {
        destinationFrom,
        destinationTo,
        journeyDate,
        guests,
        flightClass,
      },
    };
  };

  const addFlightHandler = e => {
    // Prevent the browser from reloading the page
    e.preventDefault();
    // Read the form data
    // console.log('Destination From', destinationFrom);
    // console.log('Destination To', destinationTo);
    // console.log('Journey Date', journeyDate);
    // console.log('Guests', guests);
    // console.log('flighClass', flighClass);
    dispatch(addFlight());
    setDestinationFrom('');
    setDestinationTo('');
    setFlightClass('');
    setGuests('');
    setJourneyDate('');
  };

  return (
    <div className="mt-[160px] mx-4 md:mt-[160px] relative">
      <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
        <form className="first-hero lws-inputform" onSubmit={addFlightHandler}>
          {/* <!-- From --> */}
          <div className="des-from">
            <p>Destination From</p>
            <div className="flex flex-row">
              <img src="./img/icons/Frame.svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="from"
                id="lws-from"
                required
                value={destinationFrom}
                onChange={e => setDestinationFrom(e.target.value)}
              >
                <option value="" hidden>
                  Please Select
                </option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox&apos;s Bazar</option>
              </select>
            </div>
          </div>

          {/* <!-- To --> */}
          <div className="des-from">
            <p>Destination To</p>
            <div className="flex flex-row">
              <img src="./img/icons/Frame.svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="to"
                id="lws-to"
                required
                value={destinationTo}
                onChange={e => setDestinationTo(e.target.value)}
              >
                <option value="" hidden>
                  Please Select
                </option>
                <option>Dhaka</option>
                <option>Sylhet</option>
                <option>Saidpur</option>
                <option>Cox&apos;s Bazar</option>
              </select>
            </div>
          </div>

          {/* <!-- Date --> */}
          <div className="des-from">
            <p>Journey Date</p>
            <input
              type="date"
              className="outline-none px-2 py-2 w-full date"
              name="date"
              id="lws-date"
              required
              value={journeyDate}
              onChange={e => setJourneyDate(e.target.value)}
            />
          </div>

          {/* <!-- Guests --> */}
          <div className="des-from">
            <p>Guests</p>
            <div className="flex flex-row">
              <img src="./img/icons/Vector (1).svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="guests"
                id="lws-guests"
                required
                value={guests}
                onChange={e => setGuests(e.target.value)}
              >
                <option value="" hidden>
                  Please Select
                </option>
                <option value="1">1 Person</option>
                <option value="2">2 Persons</option>
                <option value="3">3 Persons</option>
                <option value="4">4 Persons</option>
              </select>
            </div>
          </div>

          {/* <!-- Class --> */}
          <div className="des-from !border-r-0">
            <p>Class</p>
            <div className="flex flex-row">
              <img src="./img/icons/Vector (3).svg" alt="" />
              <select
                className="outline-none px-2 py-2 w-full"
                name="ticketClass"
                id="lws-ticketClass"
                required
                value={flightClass}
                onChange={e => setFlightClass(e.target.value)}
              >
                <option value="" hidden>
                  Please Select
                </option>
                <option>Business</option>
                <option>Economy</option>
              </select>
            </div>
          </div>

          <button className="addCity" type="submit" id="lws-addCity">
            <svg
              width="15px"
              height="15px"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
              />
            </svg>
            <span className="text-sm">Book</span>
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddFlight;
